import { combineReducers } from "redux";

import ConfigReducer, {
  Actions as ConfigActions,
  State as ConfigStateType,
  SET_USER_AGENT
} from "./config";

// Stying Filters
import StylingFilterReducer, {
  Actions as StylingFilterActions,
  State as StylingFilterStateType,
  GET_STYLING_FILTERS
} from "./filters";

// Stylehint Styling
import StylehintListReducer, {
  Actions as StylehintListActions,
  State as StylehintListStateType,
  GET_STYLING_STYLEHINT_LIST,
  GET_STYLING_STYLEHINT_LARGE_IMAGE_LIST
} from "./stylehintList";

// Official Styling
import OfficialListReducer, {
  Actions as OfficialListActions,
  State as OfficialListStateType,
  GET_STYLING_OFFICIAL_LIST,
  GET_STYLING_OFFICIAL_LARGE_IMAGE_LIST
} from "./officialList";

// Detail Styling
import DetailStylingReducer, {
  Actions as DetailStylingActions,
  State as DetailStylingStateType,
  GET_DETAIL_STYLING
} from "./detailStyling";

// Favorites Styling
import FavoritesStylingReducer, {
  Actions as FavoritesStylingActions,
  State as FavoritesStylingStateType,
  GET_FAVORITES_STYLING,
  POST_FAVORITES_STYLING,
  DELETE_FAVORITES_STYLING
} from "./favoritesStyling";

// Favorites Item
import FavoritesItemReducer, {
  Actions as FavoritesItemActions,
  State as FavoritesItemStateType,
  GET_FAVORITES_ITEM,
  POST_FAVORITES_ITEM,
  DELETE_FAVORITES_ITEM
} from "./favoritesItem";

// User Profile
import UserProfileReducer, {
  Actions as UserProfileActions,
  State as UserProfileStateType,
  GET_USER_PROFILE
} from "./userProfile";

// Related Styling Stylehint
import RelatedStylingStylehintReducer, {
  Actions as RelatedStylingStylehintActions,
  State as RelatedStylingStylehintStateType,
  GET_RELATED_STYLING_STYLEHINT,
  GET_STYLEHINT_CAROUSEL_LIST
} from "./relatedStylingStylehint";

// Related Styling Official
import RelatedStylingOfficialReducer, {
  Actions as RelatedStylingOfficialActions,
  State as RelatedStylingOfficialStateType,
  GET_RELATED_STYLING_OFFICIAL,
  GET_OFFICIAL_CAROUSEL_LIST
} from "./relatedStylingOfficial";

export interface CombinedReducersType {
  config: ConfigStateType;
  stylingFilters: StylingFilterStateType;
  stylehintList: StylehintListStateType;
  officialList: OfficialListStateType;
  detailStyling: DetailStylingStateType;
  favoritesStyling: FavoritesStylingStateType;
  favoritesItem: FavoritesItemStateType;
  userProfile: UserProfileStateType;
  relatedStylingStylehint: RelatedStylingStylehintStateType;
  relatedStylingOfficial: RelatedStylingOfficialStateType;
}

const rootReducer = combineReducers<CombinedReducersType>({
  config: ConfigReducer,
  stylingFilters: StylingFilterReducer,
  stylehintList: StylehintListReducer,
  officialList: OfficialListReducer,
  detailStyling: DetailStylingReducer,
  favoritesStyling: FavoritesStylingReducer,
  favoritesItem: FavoritesItemReducer,
  userProfile: UserProfileReducer,
  relatedStylingStylehint: RelatedStylingStylehintReducer,
  relatedStylingOfficial: RelatedStylingOfficialReducer
});

export default rootReducer;

export {
  ConfigActions,
  SET_USER_AGENT,
  // Styling Filters
  StylingFilterActions,
  GET_STYLING_FILTERS,
  // Stylehint Styling
  StylehintListActions,
  GET_STYLING_STYLEHINT_LIST,
  GET_STYLING_STYLEHINT_LARGE_IMAGE_LIST,
  // Official Styling
  OfficialListActions,
  GET_STYLING_OFFICIAL_LIST,
  GET_STYLING_OFFICIAL_LARGE_IMAGE_LIST,
  // Detail Styling
  DetailStylingActions,
  GET_DETAIL_STYLING,
  // Favorites Styling
  FavoritesStylingActions,
  GET_FAVORITES_STYLING,
  POST_FAVORITES_STYLING,
  DELETE_FAVORITES_STYLING,
  // Favorites Item
  FavoritesItemActions,
  GET_FAVORITES_ITEM,
  POST_FAVORITES_ITEM,
  DELETE_FAVORITES_ITEM,
  // User Profile
  GET_USER_PROFILE,
  UserProfileActions,
  // Related Styling Stylehint
  RelatedStylingStylehintActions,
  GET_RELATED_STYLING_STYLEHINT,
  GET_STYLEHINT_CAROUSEL_LIST,
  // Related Styling Official
  RelatedStylingOfficialActions,
  GET_RELATED_STYLING_OFFICIAL,
  GET_OFFICIAL_CAROUSEL_LIST
};
